// extracted by mini-css-extract-plugin
export var actions = "_dk-d";
export var benefitCard = "_dk-a";
export var benefitIcon = "_dk-b";
export var benefitLabel = "_dk-c";
export var benefits = "_dk-9";
export var bodyText = "_dk-8";
export var closeButton = "_dk-2";
export var content = "_dk-3";
export var eyebrow = "_dk-4";
export var heading = "_dk-5";
export var image = "_dk-f";
export var imagePanel = "_dk-e";
export var modal = "_dk-0";
export var shell = "_dk-1";
export var title = "_dk-6";
export var titleOffer = "_dk-7";